import { TabStatus, Ticket } from "@/components/Ticket/types";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";

type Props = {
  tabStatuses: TabStatus[];
  tickets: Ticket[];
}

export function TicketList({tabStatuses, tickets}: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const {ticketId} = useParams();
  const isSelectedTicket = !!ticketId && ticketId.length > 0;
  const navigate = useNavigate();
  const currentStatus = searchParams.get('status');
  const totalCount = tabStatuses.reduce((sum, status) => sum + status.count, 0);
  const filterByStatus = (status?: string) => {
    if (status) {
      const queryParams = new URLSearchParams({
        status: status,
      });
      navigate(`/ticket?${queryParams.toString()}`);
    } else {
      navigate('/ticket');
    }
  }

  const handleTicketSearch = () => {
    navigate('/ticket/search');
  }

  const handleCreateTicket = () => {
    navigate('/ticket/new')
  }

  return (
    <>
      <div className="button-section">
        <button
          type="button"
          className="uk-button--m uk-button-cancel width-120"
          onClick={handleTicketSearch}
        >
          DRM-Chat検索
        </button>
        <button
          type="button"
          className="uk-button--m uk-button-refer width-120"
          onClick={handleCreateTicket}
        >
          新規作成
        </button>
      </div>

      <div className="ticket-list-tbl-wrap">
        <table className="ticket-list-tbl">
          <thead>
          <tr className="header">
            <th rowSpan={2}>
              <div className="border-box"/>
              <div className="uk-flex uk-flex-center">
                管理番号
              </div>
            </th>
            <th>
              <div className="border-box"/>
              <div className="uk-flex uk-flex-center">
                ステータス
              </div>
            </th>
            <th rowSpan={2}>
              <div className="border-box"/>
              <div className="uk-flex uk-flex-center">
                問合せタイトル
              </div>
            </th>
          </tr>
          <tr className="header">
            <th>
              <div className="border-box"/>
              <div className="status-box">
                {tabStatuses?.map((status) => {
                  const mergedStatus = status.code + ':' + status.status;
                  return (
                    <div key={`progress-list-tab-status-${status.id}`}>
                      {currentStatus !== mergedStatus ?
                        <a onClick={() => filterByStatus(mergedStatus)}>{status.status}：{status.count}</a>
                        :
                        <span>{status.status}：{status.count}</span>
                      }</div>
                  )
                })}
                <div className="">
                  {currentStatus || isSelectedTicket ? <a onClick={() => filterByStatus()}>全件：{totalCount}</a> :
                    <span>全件：{totalCount}</span>}
                </div>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          {tickets?.map((ticket) => (
            <tr key={`ticket-list-${ticket.data_ticket_id}`}>
              <td>
                <div className="border-box"/>
                <div className="uk-flex uk-flex-center">{ticket.control_no}</div>
              </td>
              <td>
                <div className="border-box"/>
                <div className="uk-flex uk-flex-center">{ticket.status}</div>
              </td>
              <td>
                <div className="border-box"/>
                <div
                  className="uk-flex uk-flex-center cell-content">
                  {ticket.data_ticket_id === Number(ticketId) ?
                    <span>{ticket.inquiry_title}</span>
                    :
                    <Link to={`/ticket/${ticket.data_ticket_id}`}>
                      {ticket.inquiry_title}
                    </Link>
                  }
                </div>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </>
  )
}